export const API_SATUDATA = "http://localhost:4000/api/";

export const API_DONOR_DARAH = "https://donor-darah.rotendaokab.go.id/api/";
//"https://donordarah.rotendaokab.go.id/api/"
//'http://localhost:4000/api/';
//'https://satudata.rotendaokab.go.id/api/';

export const ADMINS_LOGIN = API_DONOR_DARAH + "admin/login";
export const ADMINS_LOGOUT = API_DONOR_DARAH + "admin/logout";
export const ADMINS_TOKEN = API_DONOR_DARAH + "admin/token";

export const LOG_APP = API_DONOR_DARAH + "logapp/";

export const API_TIMEOUT = 120000;

export const DOMAIN = "https://donordarah.rotendaokab.go.id/uploads/";

// API Endpoints untuk Darah Masuk & Keluar
export const API_DARAH_MASUK = API_DONOR_DARAH + "darah-masuk";
export const API_DARAH_KELUAR = API_DONOR_DARAH + "darah-keluar";
export const API_STOK_DARAH = API_DONOR_DARAH + "stok-darah";
export const API_LANDING_BERANDA = API_DONOR_DARAH + "landing/beranda";
export const API_DONOR_STATISTIK = API_DONOR_DARAH + "donor-statistik";
